<div class="modal-form" *ngIf="pageMode$ | async as pageMode">
    <ng-container *ngIf="hdImage">



        <h2 class="jumbotron-heading">{{hdImage.title}}</h2>

        <div style="margin-top:-10px;">
            <small>Acceptable formats: JPEG, PNG. Max file size is 5 MB</small>
        </div>

        <mat-dialog-content class="mat-typography">

            <div class="container" style="text-align:center;">

                <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

                <div *ngIf="pageMode === 'Default'">
                    <img id="currentImg" *ngIf="hdImage.url$ | async" [src]="hdImage.url$ | async"
                        [ngClass]="hdImage.darkBkg ? 'darkBkg' : ''" />

                    <div class="alert alert-warning" *ngIf="errorFetchingImageForEditing">
                        <p>This image can not be edited directly from it's hosted location.</p>
                        <p>Please download it and then use the "Upload" button below.</p>
                    </div>

                </div>

                <ng-container *ngIf="pageMode === 'Upload'">
                    <input type="file" (change)="fileChangeEvent($event)" /><br /><br />
                </ng-container>

                <ng-container *ngIf="pageMode === 'Upload' || pageMode === 'Edit' ">

                    <image-cropper [ngClass]="hdImage.darkBkg ? 'darkBkg' : ''" [imageChangedEvent]="imageChangedEvent"
                        [maintainAspectRatio]="hdImage.aspectRatio ? true : false" [aspectRatio]="hdImage.aspectRatio"
                        [imageBase64]="base64String" format="png" [resizeToHeight]="hdImage.targetHeight"
                        [onlyScaleDown]="true" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)"
                        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>

                    <div class="Vert-15"></div>

                </ng-container>

                <div *ngIf="pageMode === 'Preview'" [ngClass]="hdImage.darkBkg ? 'darkBkg' : ''">
                    <img style="max-height:200px;" [src]="croppedImage" />
                </div>

                <div class="row toolbar" *ngIf="pageMode === 'Default'">
                    <div [ngClass]="{'col-4':(hdImage.url$ | async), 'toolbar-button': true, 'col-12': (!(hdImage.url$ | async))}"
                        (click)="onUpload();">
                        <a><fa-icon icon="camera"></fa-icon><br />Upload</a>
                    </div>
                    <div *ngIf="(hdImage.url$ | async)" class="col-4 toolbar-button" (click)="onEditCurrentImage();">
                        <a><fa-icon icon="pencil-alt"></fa-icon><br />Edit</a>
                    </div>
                    <div *ngIf="(hdImage.url$ | async)" class="col-4 toolbar-button" (click)="onDelete();">
                        <a><fa-icon icon="trash"></fa-icon><br />Delete</a>
                    </div>
                </div>
            </div>



        </mat-dialog-content>

        <mat-dialog-actions class="dialog-actions" align="end">
            <button *ngIf="data.woCancelButton!=true" mat-stroked-button class="btn btn-secondary"
                (click)="onCancel()">Cancel</button>
            <ng-container *ngIf="pageMode === 'Upload' || pageMode === 'Edit' ">
                <button mat-stroked-button class="btn btn-primary" (click)="onPreview()">Preview</button>
            </ng-container>
            <ng-container *ngIf="pageMode === 'Preview' ">
                <button mat-stroked-button class="btn btn-primary" (click)="onSave()">Save</button>
            </ng-container>
        </mat-dialog-actions>

    </ng-container>
</div>